import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Silently refresh the access token on 401 (active users beyond 60 min), then retry once.
let _refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = (original && original.url) || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/refresh");
    if (error.response && error.response.status === 401 && original && !original._retry && !isAuthCall) {
      original._retry = true;
      try {
        _refreshing = _refreshing || api.post("/auth/refresh");
        await _refreshing;
        _refreshing = null;
        return api(original);
      } catch {
        _refreshing = null;
        return Promise.reject(error);
      }
    }
    if (error.response && error.response.status === 402) {
      toast.error(formatApiErrorDetail(error.response.data && error.response.data.detail));
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ha ocurrido un error. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export function fileUrl(path) {
  return `${API}/files/${path}`;
}

export async function downloadBlob(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
